// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"8e8ffda9","839":"07e35848"}[chunkId] + ".chunk.js";
};